module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.selectedPriceList), function(price) {
    return _c('div', {
      key: price.name,
      staticClass: "col-sm-4",
      class: {
        'margin-top-20': _vm.$route.query.app
      }
    }, [_c('div', {
      staticClass: "pricing"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n              " + _vm._s(price.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "thumbnail"
    }, [_c('div', {
      staticClass: "thumbnail icon"
    }, [_c('img', {
      attrs: {
        "src": price.image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "sub-title"
    }, [_vm._v("\n                " + _vm._s(price.price) + "\n                "), _c('span', [_vm._v(_vm._s(price.subPrice))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(price.priceDetail)
      }
    })]), _vm._v(" "), _c('ul', _vm._l((price.features), function(feature) {
      return _c('li', {
        key: feature.name
      }, [_c('div', {
        class: {
          'fa': true, 'fa-check': feature.checked, 'fa-close': !feature.checked
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(feature.name)
        }
      })])
    })), _vm._v(" "), _c('router-link', {
      staticClass: "sign-up-btn",
      attrs: {
        "to": price.link + _vm.addAppParams
      }
    }, [_vm._v("\n                สมัคร\n              ")])], 1)])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("เลือก Plan ของคุณ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a3e5b0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/package/Package.vue
// module id = 1028
// module chunks = 1